export default __webpack_public_path__ + "static/media/kokoro-5.7177e54c.png";